enum DeleteAnnotationDialogFields {
	PAGE = 'page'
}

export default DeleteAnnotationDialogFields;